
type ScreenshotRequest = {
    sec: number;
    box?: { x: number, y: number, w: number, h: number };
    outputSize?: { width: number, height: number };
    resolve: (value: string | PromiseLike<string>) => void;
    reject: (reason?: any) => void;
};

// Предварительно создаем элемент <video>
const video = document.createElement('video');
//let currentVideoUrl: string | null = null;
let isProcessing = false;
const queue: ScreenshotRequest[] = [];

const imageCache: Record<string | number, string> = {};

function processQueue() {
    if (queue.length === 0) {
        isProcessing = false;
        return;
    }

    isProcessing = true;
    let { sec, box, outputSize, resolve, reject } = queue.shift() as ScreenshotRequest;
    if (sec===undefined) {
        reject(new Error("Can't get scrrenshot at "+sec));
        // Переход к следующему элементу очереди
        processQueue();
        return
    }

    //console.log("trying to get screenshot at",sec)
    video.currentTime = sec;

    video.onseeked = () => {
        if (!box?.w) box = { w: video.videoWidth, h: video.videoHeight, x: 0, y: 0 };

        const canvas = document.createElement('canvas');
        // Если выходной размер задан, используем его, иначе используем размеры из box
        canvas.width = outputSize?.width || box.w;
        canvas.height = outputSize?.height || box.h;

        const ctx = canvas.getContext('2d');
        ctx?.drawImage(video, box.x, box.y, box.w, box.h, 0, 0, canvas.width, canvas.height);

        //const screenshot = canvas.toDataURL('image/png');

        //console.log("getting blob")
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error('Failed to create blob'));
                processQueue();
                return;
            }
            const screenshot = URL.createObjectURL(blob);
            imageCache[sec] = screenshot;
            resolve(screenshot);
            processQueue();
        }, 'image/png', 1)

    };

    video.onerror = (err: any) => {
        reject(err);

        // Переход к следующему элементу очереди
        processQueue();
    };
}

export function initHiddenVideo(videoUrl: string, onMetadataLoaded: (_metadata: any) => void, onError: (err: any) => void): void {
    //currentVideoUrl = videoUrl;
    video.preload = 'auto';
    video.src = videoUrl;

    video.onloadedmetadata = () => {
        console.log("metadata loaded in hidden video", video);
        const { duration, videoWidth: width, videoHeight: height } = video;
        const metadata = {
            duration,
            width,
            height,
            aspectRatio: width / height,
        }
        onMetadataLoaded(metadata)
        if (queue.length > 0) {
            processQueue();
        }
        console.log("hidden video initiated")
    };

    video.onerror = onError;
}


export function generateScreenshot(sec: number, box?: { x: number, y: number, w: number, h: number }, outputSize?: { width: number, height: number }): Promise<string> {
    return new Promise((resolve, reject) => {

        if (imageCache[sec]) resolve(imageCache[sec]);
        else {
            queue.push({ sec, box, outputSize, resolve, reject });

            // Начать обработку очереди, если это не началось и видео уже загружено
            if (!isProcessing && video.readyState >= 1) {
                processQueue();
            }
        }
    });
}

export function clearScreeshotCache() {
    Object.entries(imageCache).forEach(([key, value]) => {
        console.log(`Clearing: ${key} ${value}`);
        delete imageCache[key];
        URL.revokeObjectURL(value)
    });
}

// Очистка видеоресурсов после завершения использования (опционально)
export function clearVideoResources() {
    video.src = '';
    video.load();  // помогает освободить ресурсы
    //currentVideoUrl = null;
}
